module.exports = __webpack_public_path__ + "img/fechar.2359235f.svg";